import React from "react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger
} from "@/components/ui/dropdown-menu";
import { User, ChevronDown, LogOut } from "lucide-react";

export const UserMenu = ({ user, collapsed, navigate, handleLogout }) => (
  <div className="p-4 border-t border-border">
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className={`w-full gap-3 ${collapsed ? 'lg:justify-center lg:px-0' : 'justify-start px-4'}`} data-testid="user-menu-trigger">
          {user?.profile_picture ? (
            <img src={user.profile_picture} alt="" className="h-8 w-8 rounded-full object-cover shrink-0" />
          ) : (
            <div className="h-8 w-8 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
              <User className="h-4 w-4 text-primary" />
            </div>
          )}
          <div className={`flex-1 text-left ${collapsed ? 'lg:hidden' : ''}`}>
            <p className="text-sm font-medium truncate text-foreground">{user?.nickname || user?.name}</p>
            <p className="text-xs text-muted-foreground truncate">{user?.company_name || user?.email}</p>
          </div>
          <ChevronDown className={`h-4 w-4 text-muted-foreground ${collapsed ? 'lg:hidden' : ''}`} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuItem className="flex-col items-start">
          <p className="font-medium">{user?.name}</p>
          <p className="text-xs text-muted-foreground">{user?.email}</p>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => navigate("/profile")} data-testid="edit-profile-btn">
          <User className="mr-2 h-4 w-4" />
          Edit Profile
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handleLogout} data-testid="logout-btn">
          <LogOut className="mr-2 h-4 w-4" />
          Log out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  </div>
);
